/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateCandidateNoteDataSchema = z.object({
	content: z.string(),
})

export type UpdateCandidateNoteDataSchema = z.infer<typeof updateCandidateNoteDataSchema>
